// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/usb.js';

import { paths } from '../generated/usb';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('usb', Original, paths);
